import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { setDecisionTreeIframeSrc } from '../../actions/WorkflowActions';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import { getEnvVar } from '../../utils/env';
import ControlChangesIcon from '../components/ControlChangesIcon';
import { FORM_KEYS } from '../constants/form-manager.constants';
import { FCM_BUTTON_STYLES } from '../constants/runtime.constants';
import { getWorkflowInfo } from '../selectors/common.selectors';
import { getClosestParentWithEntityName } from '../selectors/form-manager.selectors';
import { getDecisionTreeQueryParams } from '../selectors/runtime.selectors';
import { getQueryString } from '../utils/controls/ssButtonDecisionTree.utils';

const useStyles = makeStyles({
  button: {
    minWidth: 128,
  },
  ...FCM_BUTTON_STYLES,
});

const SSButtonDecisionTree = ({
  id,
  isEditor,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
  label,
}) => {
  const translateString = useTranslation();

  const dispatch = useDispatch();
  const entityName = useFormSelector(getClosestParentWithEntityName, { id });
  const { itmId, stepId, workflowId } = useFormSelector(getWorkflowInfo);
  const { entityType } = useFormSelector(getWorkflowInfo, { formKey: FORM_KEYS.DETAIL });

  const classes = useStyles({ isControlAddedFCM });
  const decisionTreeQueryParams = useFormSelector(getDecisionTreeQueryParams, { id, entityName });

  useEffect(() => () => dispatch(setDecisionTreeIframeSrc('')), [dispatch]);

  const decisionTreeQueryString = getQueryString(decisionTreeQueryParams);
  const appUrl = getEnvVar('REACT_APP_ADMIN_APP_URL');
  const decisionTreeIframeSrc = `${appUrl}/Pages/StudioComplaintDecisionTree.aspx?${decisionTreeQueryString}`;

  const redirectUrl = useMemo(() => {
    const redirectUrlQueryParams = {
      entityType,
      formKey: `${entityType}_DETAIL`,
      itmId,
      stepId,
      workflowId,
    };

    return `${window.location.pathname}?${getQueryString(redirectUrlQueryParams)}`;
  }, [entityType, itmId, stepId, workflowId]);

  const onClickHandler = () => {
    dispatch(setDecisionTreeIframeSrc(decisionTreeIframeSrc));

    window.addEventListener('message', (event) => {
      if (event.data?.saved) {
        window.location = redirectUrl;
      } else if (event.data?.close) {
        dispatch(setDecisionTreeIframeSrc(''));
      }
    });
  };

  return (
    <span
      className={isControlAddedFCM || isControlChangedFCM ? classes.changesModeWrapper : null}
      ui-ta={getUITA('FormCtrl', 'SSButtonDecisionTree')}
      data-ss-id={id}
    >
      <Button
        color="primary"
        className={classes.button}
        disabled={isEditor || isControlHiddenFCM}
        onClick={onClickHandler}
        variant="secondary"
      >
        {label || translateString('Run Decision Tree')}
      </Button>
      {isControlChangedFCM && (
        <span className={classes.changesIcon}>
          <ControlChangesIcon id={id} />
        </span>
      )}
    </span>
  );
};
export default SSButtonDecisionTree;
